<template>
	<sf-data-table
		ref="table"
		paging
		:columns="columns"
		:rows="rows"
		selection
		:height="height"
		:pageUnit="searchPopupMPagingInfo.pageUnit"
		:totalSize="searchPopupMPagingInfo.totalSize"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- <sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveAction">{{ getMessage_('MWCC000138') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CU')" icon="square-plue" :onClick="copyPopup">{{ getMessage_('QWCC001098') }}</sf-button> -->
			<!-- 항목복사 -->
			<!-- <sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button> -->
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' },
		height: { type: String, default: '100%' }
	},
	created() {
		console.log('master Popup create수행');
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.masterPopupList;
		},
		columns() {
			return [
				// { label: 'No.', prop: 'rnum', width: '60px' },
				// { label: this.getMessage_('MWCC000141'), prop: 'status', width: '90px' }
				{
					//사용여부
					label: this.getMessage_('MWCC000145'),
					prop: 'useYn',
					width: '90px',
					form: {
						type: 'select',
						options: this.getUseYnList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{ label: 'partNo', prop: 'partNo', width: '1px' },
				{ label: this.getMessage_('QWCC000052'), prop: 'partNm', width: '100px', isDisabled: ({}) => true },
				{
					// 검사항목
					label: this.getMessage_('QWCC001058'),
					prop: 'ckuPrvsCd',
					width: '100px',
					form: {
						type: 'select',
						options: this.getCkuPrvsList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 항목분류
					label: this.getMessage_('QWCC001059'),
					prop: 'prvsClCd',
					width: '100px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 항목분류명
					label: this.getMessage_('QWCC001060'),
					prop: 'prvsClNm',
					width: '120px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 검사방법
					label: this.getMessage_('QWCC001062'),
					prop: 'ckuWayCd',
					width: '100px',
					form: {
						type: 'select',
						options: this.getCkuWayList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 규격하한
					label: this.getMessage_('QWCC001204'),
					prop: 'nrmLlmtVal',
					width: '80px',
					form: {
						maxLength: 9,
						type: 'number',
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 규격상한
					label: this.getMessage_('QWCC001205'),
					prop: 'nrmUplmVal',
					width: '80px',
					form: {
						maxLength: 5,
						type: 'number',
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 스펙
					label: this.getMessage_('QWCC001884'),
					prop: 'spcRslt',
					width: '120px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 단위
					label: this.getMessage_('RCMS000090'),
					prop: 'utmCd',
					width: '90px',
					form: {
						type: 'select',
						options: this.getUtmList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		// onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
		// 	if (!prePage || !prePageUnit) {
		// 		return; //초기 중복 조회 방지.
		// 	}
		// 	this.$sf_toggleLoading(true);
		// 	this.searchCommCdType_({ currentPage: currentPageVal, pageUnit: pageUnitVal }).finally(() => this.$sf_toggleLoading(false));
		// },
		getMstSelectedRows() {
			return this.$refs.table.getSelectedRows();
		},
		getMstClearSelection() {
			//console.log('클리어 진행');
			this.$refs.table.clearSelection();
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				return;
			}
			//console.log('222222222222222222222222');
			this.setSearchPopupMPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setSearchPopupMPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			//console.log('pageUnit', this.searchPopupMPagingInfo.pageUnit);
			//console.log('totalSize', this.searchPopupMPagingInfo.totalSize);
			this.$emit('Refresh');
		}
	}
};
</script>

<style></style>
